/* ==========================================================================
   Violaa — Collection card image swap on fabric swatch hover/click
   REQUIREMENTS (your setup already has this):
   - Swatch buttons have: class="fabric-swatch" AND data-variant-image="..."
   - Swatches live inside: .card-fabric_swatches (per your Inspect)
   ========================================================================== */

(() => {
  if (window.__VIOLAA_CARD_SWATCH_SWAP__) return;
  window.__VIOLAA_CARD_SWATCH_SWAP__ = true;

  const SWATCH_BTN_SELECTOR = "button.fabric-swatch[data-variant-image]";
  const SWATCH_CONTAINER_SELECTOR = ".card-fabric_swatches";
  const CARD_SELECTOR = ".card, .card-wrapper, .grid__item, .product-card";

  function absolutize(url) {
    if (!url) return "";
    if (url.startsWith("//")) return window.location.protocol + url;
    return url;
  }

  function getCard(el) {
    return el.closest(CARD_SELECTOR);
  }

  // Main product image = first <img> in the card that is NOT inside the swatches row
  function getMainProductImg(card) {
    if (!card) return null;
    const imgs = Array.from(card.querySelectorAll("img"));
    return (
      imgs.find((img) => !img.closest(SWATCH_CONTAINER_SELECTOR)) ||
      null
    );
  }

  function swap(card, url) {
    const img = getMainProductImg(card);
    if (!img) return;

    // Store original once
    if (!img.dataset.violaaOriginalSrc) {
      img.dataset.violaaOriginalSrc = img.currentSrc || img.getAttribute("src") || "";
    }

    img.src = url;
    img.srcset = "";

    // If inside <picture>, clear <source> srcset too
    const pic = img.closest("picture");
    if (pic) {
      const source = pic.querySelector("source");
      if (source) source.srcset = "";
    }
  }

  function restore(card) {
    const img = getMainProductImg(card);
    if (!img) return;
    const original = img.dataset.violaaOriginalSrc;
    if (!original) return;

    img.src = original;
    img.srcset = "";

    const pic = img.closest("picture");
    if (pic) {
      const source = pic.querySelector("source");
      if (source) source.srcset = "";
    }
  }

  function findSwatchBtn(target) {
    // Hovering/clicking the button itself
    const btn = target.closest(SWATCH_BTN_SELECTOR);
    if (btn) return btn;

    // Hovering/clicking the swatch <img> inside the button
    const insideImg = target.closest("button.fabric-swatch img");
    if (insideImg) return insideImg.closest(SWATCH_BTN_SELECTOR);

    return null;
  }

  // Hover = swap
  document.addEventListener(
    "mouseover",
    (e) => {
      const btn = findSwatchBtn(e.target);
      if (!btn) return;

      const card = getCard(btn);
      if (!card) return;

      const url = absolutize(btn.getAttribute("data-variant-image"));
      if (!url) return;

      swap(card, url);
    },
    true
  );

  // Mouseout from swatch button = restore
  document.addEventListener(
    "mouseout",
    (e) => {
      const btn = e.target.closest("button.fabric-swatch");
      if (!btn) return;

      // Only restore when leaving the swatch button entirely
      const toEl = e.relatedTarget;
      if (toEl && btn.contains(toEl)) return;

      const card = getCard(btn);
      if (!card) return;

      restore(card);
    },
    true
  );

  // Click = swap + keep swapped (no restore on mouseout after click)
  document.addEventListener(
    "click",
    (e) => {
      const btn = findSwatchBtn(e.target);
      if (!btn) return;

      const card = getCard(btn);
      if (!card) return;

      const url = absolutize(btn.getAttribute("data-variant-image"));
      if (!url) return;

      // Mark this card as "locked" to the clicked variant
      card.dataset.violaaLockedVariant = url;

      swap(card, url);
    },
    true
  );

  // If card is locked, prevent restoring on mouseout
  document.addEventListener(
    "mouseout",
    (e) => {
      const btn = e.target.closest("button.fabric-swatch");
      if (!btn) return;

      const card = getCard(btn);
      if (!card) return;

      if (card.dataset.violaaLockedVariant) {
        // ensure it stays on locked image
        swap(card, card.dataset.violaaLockedVariant);
      }
    },
    true
  );
})();